import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import config from '../../config';
import { useGlobalContext } from '../../GlobalContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { Add } from '../../service/EpinPurchaseService';
import { GetByRole } from '../../service/UserService';
import { GetAll } from '../../service/LevelService';

export default function EpinPurchaseNew() {
  const {
    isLoading,
    setIsLoading,
    isAppError,
    setAppError,
    appErrorMessage,
    setAppErrorMessage,
    appErrorTitle,
    setAppErrorTitle,
    appErrorMode,
    setAppErrorMode,
    appUser
  } = useGlobalContext();

  const [price, setPrice] = useState('');
  const [unit, setUnit] = useState('');
  const [purchaseDate, setPurchaseDate] = useState('');
  const [remarks, setRemarks] = useState('');

  // user foreign key
  const [userId, setUserId] = useState('');
  const [users, setUsers] = useState([]);
  const [keyword, setKeyword] = useState('');

  const FetchUser = async () => {
    setIsLoading(true);
    try {
      const response = await GetByRole("member", "active", 1, 9999, keyword);
      if (response && Array.isArray(response.users)) {
        // Filter only active categories
        const activeUsers = response.users.filter(cat => cat.status === "active");
        setUsers(activeUsers);
      } else {
        setAppError(true);
        setAppErrorMessage('No User Found.');
      }
    } catch (error) {
      setAppError(true);
      setAppErrorMessage('Error loading master data');
      setAppErrorMode('Error');
    } finally {
      setIsLoading(false);
    }
  };

  React.useEffect(() => {
    FetchUser();
  }, []); // end of foreign key fetch


  // user foreign key
  const [levelId, setLevelId] = useState(1);
  const [levels, setLevels] = useState([]);

  const FetchLevel = async () => {
    setIsLoading(true);
    try {
      const response = await GetAll(1, 9999, keyword);
      if (response && Array.isArray(response.levels)) {
        // Filter only active categories
        const activeLevels = response.levels.filter(cat => cat.status === "active");
        setLevels(activeLevels);
      } else {
        setAppError(true);
        setAppErrorMessage('No Level Found.');
      }
    } catch (error) {
      setAppError(true);
      setAppErrorMessage('Error loading master data');
      setAppErrorMode('Error');
    } finally {
      setIsLoading(false);
    }
  };

  React.useEffect(() => {
    FetchUser();
  }, []);

  React.useEffect(() => {
    FetchLevel();
  }, []);
  // end of foreign key fetch

  const saveEpinPurchase = async (event) => {
    event.preventDefault();

    //purcahse date required
    if (!purchaseDate) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Purchase date is required");
      setAppErrorMode("error");
      return;
    }
    setIsLoading(true);

    try {
      const response = await Add(userId, levelId, price, unit, purchaseDate, remarks);
      console.log(response);
      if (response.status === 200) {
        setAppError(true);
        setAppErrorTitle("Action Response");
        setAppErrorMessage(response.message || "Epin Purchase Successfully Added");
        setAppErrorMode("success");
        window.location.href = "/epinPurchase/list";
      }
      else {
        setAppError(true);
        setAppErrorTitle("Error");
        setAppErrorMessage(response.message || "Failed to add epin purchase. Please try again.");
        setAppErrorMode("error");
      }
    } catch (error) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Failed to add epin purchase. Please try again.");
      setAppErrorMode("error");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>Epin Purchase Manage | {config.appName}</title>
      </Helmet>
      <div className="container">
        <div className="page">
          <div className="page-heading">
            <h1>Epin Purchase Add</h1>
            <span>
              <Link to="/"> Dashboard </Link> / <Link to="/epinPurchase/list"> Epin Purchase List </Link> / EpinPurchase Manage
            </span>
          </div>
          <div className="page-content">
            <div className="portal">
              <div className="portal-body">
                <div className="form">
                  <form onSubmit={saveEpinPurchase} encType='multipart/form-data'>
                    <div className='row'>
                      <div className='col-lg-3 col-md-6 col-sm-6 col-12'>
                        <div className="mb-3">
                          <label className="form-label">Member</label>
                          <select
                            className="form-control"
                            value={userId} // Ensure this state is defined
                            onChange={(e) => setUserId(e.target.value)} // Update correctly
                          >
                            <option value="">Select Member</option>
                            {users.map(userOption => (
                              <option key={userOption.id} value={userOption.id}>
                                {userOption.name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div className='col-lg-3 col-md-4 col-sm-6 col-12'>
                        <div className="mb-3">
                          <label className="form-label">Price</label>
                          <input
                            className='form-control'
                            type='number'
                            value={price}
                            onChange={(e) => setPrice(e.target.value)}
                          />
                        </div>
                      </div>

                      <div className='col-lg-3 col-md-4 col-sm-6 col-12'>
                        <div className="mb-3">
                          <label className="form-label">Unit</label>
                          <input
                            className='form-control'
                            type='number'
                            value={unit}
                            onChange={(e) => setUnit(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className='col-lg-3 col-md-4 col-sm-6 col-12'>
                        <div className="mb-3">
                          <label className="form-label">Purchase Date</label>
                          <input
                            className='form-control'
                            type='date'
                            value={purchaseDate}
                            onChange={(e) => setPurchaseDate(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className='col-lg-9 col-md-4 col-sm-6 col-12'>
                        <div className="mb-3">
                          <label className="form-label">Remarks</label>
                          <input
                            className='form-control'
                            type='text'
                            value={remarks}
                            onChange={(e) => setRemarks(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className='clearfix'></div>
                      <div className='col-12 text-end'>
                        <div className="mb-3">
                          <button type='reset' className='btn btn-danger btn-md'>
                            <i className="ri-reset-right-line"></i> Reset
                          </button>
                          &nbsp;&nbsp;
                          <button type='submit' className='btn btn-success btn-md'>
                            <i className="ri-check-fill"></i> Add Epin Purchase
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
